/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_PromotedInputs */

const en_directory_home_board_promoted = /** @type {(inputs: Directory_Home_Board_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoted`)
};

const zh_directory_home_board_promoted = /** @type {(inputs: Directory_Home_Board_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助位`)
};

/**
* | output |
* | --- |
* | "Promoted" |
*
* @param {Directory_Home_Board_PromotedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_promoted = /** @type {((inputs?: Directory_Home_Board_PromotedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_PromotedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_promoted(inputs)
	return zh_directory_home_board_promoted(inputs)
});
export { directory_home_board_promoted as "directory.home.board.promoted" }